import { cn, getInitials } from '@/lib/utils'
import { Prisma } from '@prisma/client'

const StudentAvatar: React.FC<{
  size?: 'sm' | 'md' | 'lg' | 'xl'
  s: Prisma.StudentGetPayload<{
    include: {
      studentGroup: {
        include: {
          group: true
        }
      }
    }
  }>
}> = ({ s, size }) => {
  let height = 32
  let fontSize = 12
  switch (size) {
    case 'sm':
      height = 24
      fontSize = 12
      break
    case 'md':
      height = 32
      fontSize = 18
      break
    case 'lg':
      height = 58
      fontSize = 24
      break
    case 'xl':
      height = 88
      fontSize = 34
      break
  }

  function getTagClassByHex(hex: string): string {
    const colorMap: Record<string, string> = {
      '#D50000': 'bg-red-100 text-red-800 dark:bg-gray-800 dark:text-red-400',
      '#E67C73':
        'bg-pink-100 text-pink-800 dark:bg-gray-800 dark:text-pink-400',
      '#F4511E':
        'bg-orange-100 text-orange-700 dark:bg-gray-800 dark:text-orange-400',
      '#F6BF26':
        'bg-yellow-100 text-yellow-800 dark:bg-gray-800 dark:text-yellow-300',
      '#33B679':
        'bg-lime-100 text-lime-800 dark:bg-gray-800 dark:text-lime-400',
      '#0B8043':
        'bg-green-100 text-green-800 dark:bg-gray-800 dark:text-green-400',
      '#039BE5': 'bg-sky-100 text-sky-800 dark:bg-gray-800 dark:text-sky-400',
      '#3F51B5':
        'bg-indigo-100 text-indigo-800 dark:bg-gray-800 dark:text-indigo-400',
      '#7986CB':
        'bg-purple-200 text-purple-900 dark:bg-gray-800 dark:text-purple-500',
      '#8E24AA':
        'bg-violet-100 text-violet-800 dark:bg-gray-800 dark:text-violet-400',
      '#616161':
        'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-400',
    }

    return (
      colorMap[hex] ||
      'bg-stone-100 text-stone-800 dark:bg-stone-800 dark:text-stone-400'
    )
  }

  return (
    <div
      style={{
        height,
        fontSize,
        width: height,
      }}
      className={cn(
        `flex items-center justify-center rounded-full p-1 ${getTagClassByHex(s.studentGroup[0]?.group?.groupColor || '')}`,
        {
          'bg-purple-400': !s.studentGroup,
        },
      )}
    >
      <div className="font-bold">
        {getInitials(`${s.firstName} ${s.lastName}`).toUpperCase()}
      </div>
    </div>
  )
}

export default StudentAvatar
